/**
 * Order CSV export shape: the field-key sequence picked from each
 * order row, plus the `{ key, label }` `react-csv` headers built
 * from it via i18n. Ported 1:1 from
 * `_legacy/components/Orders/constants.js`.
 *
 * `CSV_FIELDS` is kept module-internal — the only consumer is
 * `CSV_HEADERS` two lines below. Callers import `CSV_HEADERS`
 * via `@entities/order`.
 *
 * `CSV_FILENAME` (legacy `Orders ${getFormattedDate(new Date)}.csv`
 * with the forbidden MM/DD/YYYY slash format) was dropped — it had
 * zero live references. The single client-side caller,
 * `@widgets/orders-table/OrdersTableActions.jsx:106`, already builds
 * the filename inline via the canonical `buildDownloadFileName(
 * 'Orders', 'csv')` helper.
 */
import i18next from 'i18next';

const CSV_FIELDS = [
  'accountCustomIdentifier',
  'organization',
  'firstName',
  'lastName',
  'dob',
  'gender',
  'allergies',
  'patientPhone',
  'patientAddress',
  'clinician',
  'npi',
  'shipTo',
  'category',
  'type',
  'formula',
  'qty',
  'geography',
  'date',
  'expectedDeliveryDate',
  'comments',
];

export const CSV_HEADERS = CSV_FIELDS.map(csvField => ({
  key: csvField,
  label: i18next.t(`ordersCsv:${csvField}`),
}));
